import { render, staticRenderFns } from "./Toutiao.vue?vue&type=template&id=bdc3ab1a&scoped=true"
import script from "./Toutiao.vue?vue&type=script&lang=js"
export * from "./Toutiao.vue?vue&type=script&lang=js"
import style0 from "./Toutiao.vue?vue&type=style&index=0&id=bdc3ab1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdc3ab1a",
  null
  
)

export default component.exports